import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import { Row } from "reactstrap";
import { CasesService } from 'src/share/services/cases';
import { IAuthState } from 'src/modules/Auth/store/types';
import { getAgencyByRole } from 'src/share/utils/auth';
import _ from 'lodash';
import { IIndexedCase } from 'src/share/types/case/searchCase';

export interface ICaseSugesterProps {
  auth: IAuthState;
  onSelect: (selectCase: IIndexedCase) => any;
  onChange: (caseId: string) => void
  caseId: string
  isEdit: boolean;
}

export interface ICaseSugesterState {
  suggestions: IIndexedCase[]
}
const escapeRegexCharacters = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}



export default class CaseSugester extends React.Component<ICaseSugesterProps, ICaseSugesterState> {
  constructor(props: ICaseSugesterProps) {
    super(props);
    this.state = {
      suggestions: []
    }
  }
  public setSuggestions = _.debounce(async (value) => {
    const data = await this.getSuggentions(value)
    return new Promise<void>((res) => this.setState({ suggestions: data }, res as () => void))
  }, 500);
  public getSuggentions = async (value) => {
    const search = escapeRegexCharacters(value.trim());
    const data = await CasesService.autocompleteSearchCases({ search, agency: getAgencyByRole(this.props.auth) })
    return data.cases.results;
  }
  public getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  public renderSuggestion = (suggestion) => {
    return (
      <span>{suggestion.name}</span>
    );
  }
  public onChange = async (event, { newValue, method }) => {
    this.props.onChange(newValue)
    const selected = this.state.suggestions.find((caseData) => caseData.caseId === newValue && !!caseData.agencyCode);
    if (selected) {
      this.props.onSelect(selected)
    } else {
      const suggestions = await this.getSuggentions(newValue);
      const selectedDB = suggestions.find((caseData) => caseData.caseId === newValue && !!caseData.agencyCode);
      if (selectedDB) {
        this.props.onSelect(selectedDB)
      }
    }
  };

  public onSuggestionsFetchRequested = async ({ value }) => {
    this.setState({ suggestions: [{ caseId: 'Loading ...' } as IIndexedCase] })
    this.setSuggestions(value)
  };

  public onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };


  public render() {
    const inputProps = {
      placeholder: "Enter ID",
      value: this.props.caseId,
      onChange: this.onChange,
      required: true,
      name: 'alertCaseID',
      className: "form-control",
      disabled: this.props.isEdit
    };

    return (
      <Row className="input">
        <div className="caseSugester no-padding-left">
          <Autosuggest
            suggestions={this.state.suggestions.map((caseData) => ({ name: caseData.caseId }))}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps} />
        </div>
      </Row>
    );
  }
}
